import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {AirbnbAuth, AirbnbRedirectVerification} from '../../../../models/airbnbAuthModel';
import {PillButton} from '../../../../components/Button';
import {RouteComponentProps, withRouter} from 'react-router';

interface AirbnbFinishRedirectVerificationButtonProps {
  method: AirbnbRedirectVerification;
}

interface WithInjectedProps extends AirbnbFinishRedirectVerificationButtonProps, RouteComponentProps {
  airbnbAuth: AirbnbAuth;
}

@inject('airbnbAuth')
@observer
class AirbnbFinishRedirectVerificationButton extends React.Component<
  AirbnbFinishRedirectVerificationButtonProps & RouteComponentProps,
  {}
> {
  public render() {
    return (
      <PillButton onClick={this._handleClick} variant="secondary">
        I've done it
      </PillButton>
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private _handleClick = () => {
    this._withInjectedProps.airbnbAuth.finishRedirectVerification(this._handleVerificationSuccess);
  };

  private _handleVerificationSuccess = () => {
    this._withInjectedProps.history.push('/connect/airbnb/choose_listings');
  };
}

export default withRouter(AirbnbFinishRedirectVerificationButton);



// WEBPACK FOOTER //
// ./src/containers/AirbnbRedirectVerificationProcedure/private/AirbnbFinishRedirectVerificationButton/AirbnbFinishRedirectVerificationButton.tsx